class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ===== OXIES: PRICE RANGE SLIDER - START =====
   Adds a dual-handle slider above the price filter and restyles the min/max
   boxes as rounded pills. Delete everything between the START and END markers
   to revert to the default Dawn price filter. */
(function () {
  var STYLE_ID = 'oxies-price-slider-styles';

  var CSS = [
    '.oxies-price-slider{position:relative;height:2.4rem;margin:1.2rem 0 1.6rem;}',
    '.oxies-price-slider__track{position:absolute;left:1.1rem;right:1.1rem;top:50%;transform:translateY(-50%);height:.4rem;background:rgba(var(--color-foreground),.15);border-radius:.4rem;}',
    '.oxies-price-slider__fill{position:absolute;top:0;bottom:0;background:rgb(var(--color-foreground));border-radius:.4rem;}',
    '.oxies-price-slider input[type="range"]{position:absolute;top:0;left:0;width:100%;height:2.4rem;margin:0;padding:0;background:transparent;pointer-events:none;-webkit-appearance:none;appearance:none;}',
    '.oxies-price-slider input[type="range"]:focus{outline:0;}',
    '.oxies-price-slider input[type="range"]::-webkit-slider-runnable-track{height:2.4rem;background:transparent;border:0;}',
    '.oxies-price-slider input[type="range"]::-moz-range-track{height:2.4rem;background:transparent;border:0;}',
    '.oxies-price-slider input[type="range"]::-webkit-slider-thumb{-webkit-appearance:none;pointer-events:auto;height:2.2rem;width:2.2rem;border-radius:50%;background:rgb(var(--color-background));border:.2rem solid rgb(var(--color-foreground));box-shadow:0 .1rem .3rem rgba(0,0,0,.15);cursor:pointer;}',
    '.oxies-price-slider input[type="range"]::-moz-range-thumb{pointer-events:auto;height:2.2rem;width:2.2rem;border-radius:50%;background:rgb(var(--color-background));border:.2rem solid rgb(var(--color-foreground));box-shadow:0 .1rem .3rem rgba(0,0,0,.15);cursor:pointer;}',
    '.oxies-price-slider input[type="range"]:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 .3rem rgba(var(--color-foreground),.25);}',
    '.oxies-price-slider input[type="range"]:focus-visible::-moz-range-thumb{box-shadow:0 0 0 .3rem rgba(var(--color-foreground),.25);}',
    'price-range.oxies-price-fields{display:flex;align-items:center;gap:0;}',
    'price-range.oxies-price-fields .field{display:flex;align-items:center;gap:.6rem;flex:1 1 0;min-width:0;margin:0;}',
    'price-range.oxies-price-fields .field:before,price-range.oxies-price-fields .field:after{display:none!important;}',
    'price-range.oxies-price-fields .field-currency{color:rgb(var(--color-foreground));opacity:1!important;font-size:1.4rem;line-height:1;margin-right:.5rem!important;margin-left:0!important;}',
    'price-range.oxies-price-fields .field+.field-currency{margin-left:1.6rem!important;}',
    'price-range.oxies-price-fields .field__input{flex:1 1 auto;width:100%;min-width:0;height:4.4rem;padding:0 1.4rem!important;border:.1rem solid rgba(var(--color-foreground),.25)!important;border-radius:5rem!important;box-shadow:none!important;background:rgb(var(--color-background));font-size:1.4rem;}',
    'price-range.oxies-price-fields .field__input::placeholder{opacity:1!important;color:rgba(var(--color-foreground),.5);}',
    'price-range.oxies-price-fields .field__input::-webkit-input-placeholder{opacity:1!important;color:rgba(var(--color-foreground),.5);}',
    'price-range.oxies-price-fields .field__input::-moz-placeholder{opacity:1!important;color:rgba(var(--color-foreground),.5);}',
    'price-range.oxies-price-fields .field__input:focus{border-color:rgb(var(--color-foreground))!important;box-shadow:0 0 0 .1rem rgb(var(--color-foreground))!important;}',
    'price-range.oxies-price-fields .field__label{position:absolute!important;width:.1rem;height:.1rem;margin:-.1rem;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}'
  ].join('');

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function toNumber(value) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? null : parsed;
  }

  function ensureFieldCurrency(priceRange, fieldDiv, symbol) {
    var prev = fieldDiv.previousElementSibling;
    if (prev && prev.classList.contains('field-currency')) return prev;
    var span = document.createElement('span');
    span.className = 'field-currency oxies-price-currency';
    span.textContent = symbol;
    priceRange.insertBefore(span, fieldDiv);
    return span;
  }

  function buildSlider(priceRange) {
    if (priceRange.dataset.oxiesSlider === 'true') return;

    var allInputs = priceRange.querySelectorAll('input');
    var minInput = priceRange.querySelector('input[name*="price.gte"]') || allInputs[0];
    var maxInput = priceRange.querySelector('input[name*="price.lte"]') || allInputs[1];
    if (!minInput || !maxInput) return;

    var rawMax = toNumber(maxInput.getAttribute('max'));
    if (rawMax === null || rawMax <= 0) return;
    var rangeMax = Math.ceil(rawMax);
    var step = rangeMax <= 20 ? 0.5 : 1;

    priceRange.dataset.oxiesSlider = 'true';
    priceRange.classList.add('oxies-price-fields');

    var minField = minInput.parentNode;
    var maxField = maxInput.parentNode;
    var existingCurrency = priceRange.querySelector('.field-currency');
    var symbol = existingCurrency ? existingCurrency.textContent.trim() : '\u00A3';
    ensureFieldCurrency(priceRange, minField, symbol);
    ensureFieldCurrency(priceRange, maxField, symbol);

    minInput.setAttribute('placeholder', '0');
    maxInput.setAttribute('placeholder', String(rangeMax));

    [minInput, maxInput].forEach(function (input, index) {
      if (input.getAttribute('aria-label')) return;
      var label = input.id ? priceRange.querySelector('label[for="' + input.id + '"]') : null;
      var text = label ? label.textContent.trim() : '';
      input.setAttribute('aria-label', text || (index === 0 ? 'Minimum price' : 'Maximum price'));
    });

    var wrapper = document.createElement('div');
    wrapper.className = 'oxies-price-slider';
    wrapper.innerHTML = '<div class="oxies-price-slider__track"><div class="oxies-price-slider__fill"></div></div>';

    var sliderMin = document.createElement('input');
    var sliderMax = document.createElement('input');
    [sliderMin, sliderMax].forEach(function (element) {
      element.type = 'range';
      element.min = '0';
      element.max = String(rangeMax);
      element.step = String(step);
      element.tabIndex = -1;
      element.setAttribute('aria-hidden', 'true');
      ['input', 'change'].forEach(function (type) {
        element.addEventListener(type, function (event) { event.stopPropagation(); });
      });
      wrapper.appendChild(element);
    });

    priceRange.parentNode.insertBefore(wrapper, priceRange);
    var fill = wrapper.querySelector('.oxies-price-slider__fill');

    function clampToRange(value, fallback) {
      if (value === null) return fallback;
      return Math.min(Math.max(value, 0), rangeMax);
    }

    function paint() {
      var low = Number(sliderMin.value);
      var high = Number(sliderMax.value);
      fill.style.left = (low / rangeMax) * 100 + '%';
      fill.style.width = Math.max(0, (high - low) / rangeMax) * 100 + '%';
      var minOnTop = low >= rangeMax - step * 2;
      sliderMin.style.zIndex = minOnTop ? '4' : '2';
      sliderMax.style.zIndex = minOnTop ? '2' : '4';
    }

    function syncFromInputs() {
      sliderMin.value = String(clampToRange(toNumber(minInput.value), 0));
      sliderMax.value = String(clampToRange(toNumber(maxInput.value), rangeMax));
      if (Number(sliderMin.value) > Number(sliderMax.value)) sliderMin.value = sliderMax.value;
      paint();
    }

    function writeToInputs(commit) {
      var low = Number(sliderMin.value);
      var high = Number(sliderMax.value);
      minInput.value = low <= 0 ? '' : String(low);
      maxInput.value = high >= rangeMax ? '' : String(high);
      if (!commit) return;
      [minInput, maxInput].forEach(function (input) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    function onSliderMove(source, commit) {
      var low = Number(sliderMin.value);
      var high = Number(sliderMax.value);
      if (low > high) {
        if (source === 'min') sliderMin.value = String(high);
        else sliderMax.value = String(low);
      }
      paint();
      writeToInputs(commit);
    }

    sliderMin.addEventListener('input', function () { onSliderMove('min', false); });
    sliderMax.addEventListener('input', function () { onSliderMove('max', false); });
    sliderMin.addEventListener('change', function () { onSliderMove('min', true); });
    sliderMax.addEventListener('change', function () { onSliderMove('max', true); });

    minInput.addEventListener('input', syncFromInputs);
    maxInput.addEventListener('input', syncFromInputs);

    syncFromInputs();
  }

  function initAll() {
    injectStyles();
    document.querySelectorAll('price-range').forEach(buildSlider);
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  onReady(function () {
    initAll();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        initAll();
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
/* ===== OXIES: PRICE RANGE SLIDER - END ===== */
